const SCHEMA_COMPONENT_ID_BY_RUNTIME_COMPONENT = Object.freeze({
    TextInput: 'Input',
});
export function schemaComponentIdForRuntimeComponent(componentId) {
    return SCHEMA_COMPONENT_ID_BY_RUNTIME_COMPONENT[componentId] ?? componentId;
}
//# sourceMappingURL=component-aliases.js.map